import { Padding_$ctor_Z207A3CFB, PaddingDirection_$ctor_Z207A3CFB } from "../Types/Padding.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const PaddingTop = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(205));

export const PaddingRight = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(204));

export const PaddingBottom = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(202));

export const PaddingLeft = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(203));

export const PaddingInlineStart = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(207));

export const PaddingInlineEnd = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(208));

export const PaddingBlockStart = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(209));

export const PaddingBlockEnd = PaddingDirection_$ctor_Z207A3CFB(new Property_CssProperty(210));

export const Padding = Padding_$ctor_Z207A3CFB(new Property_CssProperty(206));

